import { MapLegend } from './MapLegend';
import type { PriceChangeStop } from '../utils/mapScales';

const formatPercent = (pct: number): string => {
  const rounded = Number(pct.toFixed(1));
  return `${rounded > 0 ? '+' : ''}${rounded}%`;
};

/**
 * Labels for the diverging scale, top of the bar first.
 *
 * The ends of the ramp saturate: a hex rising faster than the top stop is
 * painted the same as one sitting on it, so those two labels say "at least"
 * rather than naming an exact rate.
 */
const changeLabels = (stops: PriceChangeStop[]): string[] => {
  const last = stops.length - 1;
  return stops
    .map((stop, index) => {
      if (index === last && stop.pct > 0) {
        return `≥ ${formatPercent(stop.pct)}`;
      }
      if (index === 0 && stop.pct < 0) {
        return `≤ ${formatPercent(stop.pct)}`;
      }
      return formatPercent(stop.pct);
    })
    .reverse();
};

export function PriceChangeLegend({ stops, perSqft = false }: { stops: PriceChangeStop[]; perSqft?: boolean }) {
  if (stops.length < 2) {
    return null;
  }
  return (
    <MapLegend
      title={perSqft ? 'Price per sq ft change per year' : 'Sale price change per year'}
      colors={stops.map((stop) => stop.color)}
      labels={changeLabels(stops)}
    />
  );
}
